<script>
import { EVENT_TYPE } from '../js/event/event';
import { store } from '../store';
import { settingStore } from '../js/store/settingStore';
import { windowContentScaleX, windowContentScaleY } from '../js/common/content_scale';

export default {
    name: "dragElem",
    data: function () {
        return {
            top: 0,
            left: 0,
            deltaMouse: { x: 0, y: 0 },
            currentTargetSize: {width: 0, height: 0},
            horizonLimit: 0,
            dragMargin: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            outTimeoutId: null,
            moveCount: 0,
            limit: true,
            parentScale: 1
        }
    },
    methods: {
        startDrag: function (e, target = null, margin = null, parentScale = 1) {
            console.log("start drag")
            if (e.currentTarget != e.target) return;
            this.pointerType = e.pointerType;
            this.parentScale = parentScale;
            this.deltaMouse.x = (e.clientX / windowContentScaleX.value / this.parentScale - this.left);
            this.deltaMouse.y = (e.clientY / windowContentScaleY.value / this.parentScale - this.top);


            let currentTargetRect;

            if(target == null) {
                currentTargetRect = {
                    width: e.currentTarget.offsetWidth || e.currentTarget.clientWidth,
                    height: e.currentTarget.offsetHeight || e.currentTarget.clientHeight
                };
            }else {
                const rect = target.getBoundingClientRect();
                currentTargetRect = {
                    width: rect.width / windowContentScaleX.value / this.parentScale,
                    height: rect.height / windowContentScaleY.value / this.parentScale 
                }
            }

            this.currentTargetSize.width = currentTargetRect.width;
            this.currentTargetSize.height = currentTargetRect.height;

            this.horizonLimit = 0;// settingStore.isFixed == 0 ? store.contentSize.x : 0;

            if(margin != null) {
                this.dragMargin = margin
            }
            // console.log(`this.horizonLimit ${this.horizonLimit}`, store.globalPaintData.margin);

            // this.deltaMouse.x = e.clientX - this.left;
            // this.deltaMouse.y = e.clientY - this.top;
            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.drag);
            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.endDrag);
            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":out"), this.outOfEndDrag);
        },
        drag: function (e) {
            let newLeft, newTop;
            
            if (e.type == "pointermove" || e.type == "mousemove") {
                newLeft = (e.clientX / windowContentScaleX.value / this.parentScale - this.deltaMouse.x);
                newTop = (e.clientY / windowContentScaleY.value / this.parentScale - this.deltaMouse.y);
            } else {
                newLeft = e.touches[0].screenX / windowContentScaleX.value / this.parentScale - this.deltaMouse.x;
                newTop = e.touches[0].screenY / windowContentScaleY.value / this.parentScale - this.deltaMouse.y;
            }

            if(this.limit) {
                if(newLeft < 0 + this.horizonLimit - this.dragMargin.left) {
                    newLeft = 0 + this.horizonLimit - this.dragMargin.left;
                }
                if(newLeft + this.currentTargetSize.width > store.baseSize.width - this.horizonLimit + this.dragMargin.right) {
                    newLeft = store.baseSize.width - this.currentTargetSize.width - this.horizonLimit + this.dragMargin.right;
                    console.log(`${newLeft} = ${store.baseSize.width} - ${this.currentTargetSize.width} - ${this.horizonLimit} + ${this.dragMargin.right}`);
    
                }
                if(newTop < 0 - this.dragMargin.top) {
                    newTop = 0 - this.dragMargin.top;
                }
                if(newTop + this.currentTargetSize.height > store.baseSize.height - store.toolbarHeight + this.dragMargin.bottom) {
                    newTop = store.baseSize.height - store.toolbarHeight - this.currentTargetSize.height + this.dragMargin.bottom;
                }
    
            }
            this.left = newLeft;
            this.top = newTop;
            this.moveCount++;

            if (this.moveCount > 1) {
                clearTimeout(this.outTimeoutId);
                this.outTimeoutId = null;
            }
        },
        endDrag: function (e) {
            this.dragMargin = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.drag);
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.endDrag);
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":out"), this.outOfEndDrag);
        },
        outOfEndDrag: function (e) {
            if (this.outTimeoutId) return;

            this.moveCount = 0;
            this.outTimeoutId = setTimeout(() => {
                this.endDrag(e);
            }, 100);
        },
        cancelDrag: function (e) {
            e.stopPropagation();
        }

    }
}
</script>